import Vue from 'vue'

/** Le classement des types (ZEborne seul) : Constructeur › Gamme › Type ; gammes et constructeurs se fusionnent. */
class ProductLineRepository {

  // { lines: [{ id, name, models, chargingPoints, types }], suggestions: [{ prefix, productLineIds, chargingPoints }] }
  ofManufacturer(manufacturerId) {
    return this.fetch({ url: `/api/manufacturers/${manufacturerId}/product-lines`, method: 'get' })
  }

  rename(productLineId, name) {
    return this.fetch({ url: `/api/product-lines/${productLineId}`, method: 'put', data: { name } })
  }

  // La première gamme reste, les autres s'y fondent → { id }
  merge(productLineIds, name) {
    return this.fetch({ url: '/api/product-lines/merge', method: 'post', data: { productLineIds, name } })
  }

  // Dans une autre gamme de son constructeur, ou dans une gamme à lui seul (productLineId null)
  place(chargingPointTypeId, productLineId) {
    return this.fetch({ url: `/api/charging-point-types/${chargingPointTypeId}/product-line`, method: 'put', data: { productLineId } })
  }

  // Le constructeur manufacturerId disparaît dans targetId (deux écritures d'une même marque)
  mergeManufacturer(manufacturerId, targetId) {
    return this.fetch({ url: `/api/manufacturers/${manufacturerId}/merge-into/${targetId}`, method: 'post' })
  }

  fetch(options) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch(options)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  }
}

export default new ProductLineRepository()
